import { type Activity, strongestActivity } from '@/types/activity'

/** Each source of background work and its activity, keyed by the source's name. */
export type ActivitySources = Readonly<Record<string, Activity>>

/** The sources that worked while the tab was hidden, so their outcome has not been seen; empty once the tab is visible again. */
export function unseenSources(
  sources: ActivitySources,
  hidden: boolean,
  unseen: ReadonlySet<string>,
): ReadonlySet<string> {
  if (!hidden) return new Set()
  const next = new Set(unseen)
  for (const [name, activity] of Object.entries(sources)) {
    if (activity === 'working') next.add(name)
  }
  return next
}

/** What the tab shows: work in flight always, and an outcome only for work that ended unseen. */
export function tabActivity(sources: ActivitySources, unseen: ReadonlySet<string>): Activity {
  return strongestActivity(
    Object.entries(sources).map(([name, activity]) =>
      activity === 'working' || unseen.has(name) ? activity : 'idle',
    ),
  )
}
